export default {
    bot_description: "Боттун сыпаттамасы",
    bot_name: "Боттун аты",
    clinic_account: " Клиниканын аккаунт",
    clinic_site_link: "Клиниканын сайтына шилтеме",
    code_for_bonus_payment: "Бонустар менен төлөө үчүн код",
    code_was_not_sent: "Код жөнөтүлгөн жок - бейтап телеграм ботуна туташуусун текшериши керек",
    code_was_sent_to_patient_through_bot: "Код бейтапка телеграм боту аркылуу жөнөтүлгөн",
    connected_to_telegram_bot: "Телеграм ботуна туташылган",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Бот клиникадагы бейтаптарга бонустарды чогултууга жана алардын баруусу тууралуу акыркы маалыматты алууга жардам берет",
    telegram_bot_instruction_1: "Telegram мессенджерин ачып, каттоо эсебиңизге кириңиз же жаңысын түзүңүз. Издөө талаасына киргизиңиз <code>{'@'}BotFather</code> жана ботту тандаңыз",
    telegram_bot_instruction_2: "Тандап же жазып, команданы жөнөтүңүз <code>/newbot</code>",
    telegram_bot_instruction_3: "Ботко ат коюңуз - кардарлар бот менен баарлашканда бул атты көрүшөт. Жана боттун никнеймин — ал боюнча ботту  Telegram-дан табууга болот. Никнеймуникалдуу болушу керек, маалымат базасында барларды кайталабашы керек жана bot деген сөз менен аякташы керек",
    telegram_bot_instruction_4: "Түзүлгөн боттон токендин маанисин көчүрүп, төмөнкү талаага коюп, сактаңыз",
    use_bonuses_by_confirming_through_telegram_bot: "Telegram боту аркылуу тастыктоо менен бонустарды алуу",
    wrong_code: "Код жараксыз"
}
